import { memo, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometrySchoolsList.module.scss";
import axios from "axios";
import { ISchool } from "shared/types/schooll";
import { Layout } from "components/Layout";
import { BackButton } from "components/BackButton";
import { Link } from "react-router-dom";

interface SociometrySchoolsListProps {
    className?: string;
}

export const SociometrySchoolsList = memo((props: SociometrySchoolsListProps) => {
    const { className } = props;

    const [schools, setSchools] = useState<ISchool[]>([]);
    useEffect(() => {
        (async () => {
            const { data } = await axios.get<ISchool[]>("sociometry/psych/schools");
            setSchools(data);
        })();
    }, []);

    return (
        <Layout>
            <div className={classNames(cls.sociometrySchoolsList, {}, [className])}>
                <header className={cls.header}>
                    <BackButton />
                    <p className={cls.title}>Статистика</p>
                </header>

                <div className={cls.schoolsList}>
                    {schools.map((school, index) => (
                        <Link key={index} className={cls.school} to={`/sociometry/schools/${school._id}`}>
                            <p className={cls.schoolsName}>{school.name}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </Layout>
    );
});

SociometrySchoolsList.displayName = "SociometrySchoolsList";
